module.exports = __webpack_public_path__ + "images/discover_data-science-career-guide.jpg";